module.exports = __webpack_public_path__ + "img/kill-title.866823a9.png";